import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Radar } from 'lucide-react';
import { VerdictBadge } from './Verdict';
import { scoutScanCandidate, getScoutCandidateScan, apiError } from '../../services/scoutApi';

const fromScan = (r) => ({ scan_id: r.id, verdict: r.status === 'failed' ? 'failed' : r.verdict, trust_score: r.trust_score, override: r.override });

// Trust badge next to a candidate's name: opens the Scout report, or starts a scan when there is none
export const ScoutBadge = ({ candidate, readOnly }) => {
  const navigate = useNavigate();
  const [live, setLive] = useState(null);
  const s = live || candidate.scout;
  const scanning = s?.verdict === 'scanning';

  useEffect(() => { setLive(null); }, [candidate.scout?.scan_id, candidate.scout?.verdict]);
  useEffect(() => {
    if (!scanning) return undefined;
    const id = setInterval(async () => {
      try { const r = await getScoutCandidateScan(candidate.id); if (r.status !== 'running') setLive(fromScan(r)); } catch { /* scan not created yet */ }
    }, 4000);
    return () => clearInterval(id);
  }, [scanning, candidate.id]);

  const open = () => s?.scan_id && navigate(`/scout/${s.scan_id}`);
  if (scanning) {
    return <button onClick={open} title="Scout is scanning" data-testid={`scout-badge-${candidate.id}`}><VerdictBadge verdict="running" /></button>;
  }
  if (s?.scan_id) {
    return (
      <button onClick={open} title={s.override ? 'Verified by a recruiter' : 'Open Scout report'} data-testid={`scout-badge-${candidate.id}`}>
        <VerdictBadge verdict={s.override && s.verdict === 'high_risk' ? 'review' : s.verdict} score={s.trust_score} />
      </button>
    );
  }
  if (readOnly) return null;
  const scan = async () => {
    setLive({ verdict: 'scanning' });
    try { await scoutScanCandidate(candidate.id); toast.success(`Scout is scanning ${candidate.name}`); } catch (e) { toast.error(apiError(e)); setLive(null); }
  };
  return (
    <button onClick={scan} title="Run a Scout fraud scan" className="inline-flex items-center gap-1 rounded-full border border-dashed px-2 py-0.5 text-[11px] font-semibold text-muted-foreground hover:text-primary hover:border-primary/50 transition-colors" data-testid={`scout-scan-btn-${candidate.id}`}>
      <Radar className="h-3.5 w-3.5" /> Scan
    </button>
  );
};

export default ScoutBadge;
